<template>
  <div class=''>
      <Header :widthmun='windowWidth'/>

      <!-- 轮播图 -->
      <div class="top_lb_box">
        <el-carousel :interval="5000"  arrow="always">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <!-- class="img_box" -->
            <div  :style="{backgroundImage: 'url(' + '/file-server/file/download?fileId=' + item.imageId + ')'}" class="banner">
            </div>
          </el-carousel-item>
        </el-carousel>

        

        <!-- <el-carousel :interval="5000" height="660px" arrow="always">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <div class="img_box" :style="{backgroundImage: 'url(' + '/file-server/file/download?fileId='+item.imageId + ')',height:'660px',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}">
              <div class="img_cont_box" v-if="lang == 'en-US'">
                <h2>{{ item.titleEn }}</h2>
                <p>{{ item.textEn }}</p>
              </div>
              <div class="img_cont_box" v-if="lang == 'zh-CN'">
                <h2>{{ item.titleZh }}</h2>
                <p>{{ item.textZh }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel> -->

        <!-- <el-carousel :interval="5000"  v-autoimg="[100,34.375]" :style="{width:windowWidth+'px',minWidth:'750px'}" arrow="always" autoplay="false">
          <el-carousel-item v-for="(item,index) in $t('home.imglist1')"  style="width:100%;height:100%" :key="index">
            <div class="img_box" :style="{backgroundImage: 'url(' + item.img + ')',width:'100%',height:'100%',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}">
            </div>
          </el-carousel-item>
        </el-carousel> -->
        <!-- <el-carousel :interval="5000" v-autoimg="[100,34.375]" :style="{width:windowWidth+'px',minWidth:'750px'}" :arrow="windowWidth<1400?'never':'always'">
          <el-carousel-item v-for="(item,index) in bannerList" style="width:100%;height:100%" :key="index">
            <div class="img_box" :style="{backgroundImage: 'url(' + '/file-server/file/download?fileId='+item.imageId + ')',height:'100%',width:'100%',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}">
              <div class="img_cont_box" v-if="lang == 'en-US'">
                <h2>{{ item.titleEn }}</h2>
                <p>{{ item.textEn }}</p>
              </div>
              <div class="img_cont_box" v-if="lang == 'zh-CN'">
                <h2>{{ item.titleZh }}</h2>
                <p>{{ item.textZh }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel> -->
      </div>

      <!-- 新闻 -->
      <div >
        <el-row>
          
          <!-- 行业新闻 -->
            <el-col  :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="background:#EDF4F8;">
                <img :src="$t('home.newsimg')" ref="imgani" alt="" style="width:100%">

                <!-- 新版新闻 -->
                <div class="new_box">
                  <div id="w23389_widget"></div>
                </div>
                <!-- <div class="new_box">
                  <el-row type="flex" justify="space-between">
                    <el-col :span="12"><h3>{{$t('home.news')}}</h3></el-col>
                    <el-col :span="12" style="text-align:right"><p class="more_box" @click="gotonews('')">{{$t('home.more')}}</p></el-col>
                  </el-row>
                </div>
                <div class="new_list">
                  <el-row type="flex" v-for="(item,index) in newsList" :key="index" justify="space-between">
                    
                      <el-col v-if="lang == 'en-US'" :span="18"><el-link :underline="false"  @click="gotonews(item)">{{item.titleEn}}</el-link></el-col>
                      <el-col v-if="lang == 'en-US'" :span="6" style="text-align:right"><p>{{item.releaseDateEn}}</p></el-col>
                  

                  
                      <el-col v-if="lang == 'zh-CN'" :span="18"><el-link :underline="false"  @click="gotonews(item)">{{item.titleZh}}</el-link></el-col>
                      <el-col v-if="lang == 'zh-CN'" :span="6" style="text-align:right"><p>{{formatDates(item.releaseDateZh)}}</p></el-col>
                    
                    
                  </el-row>
                </div> -->
            </el-col>

            <!-- 公司新闻 -->
            <el-col  :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="background:#fff">
                <div class="new_box_cp">
                  <el-row type="flex" justify="space-between">
                    <el-col :span="12"><h3>{{$t('home.cpnews')}}</h3></el-col>
                    <el-col :span="12"  style="text-align:right"><p class="more_box" @click="gotocpnews('')">{{$t('home.more')}}</p></el-col>
                  </el-row>
                </div>
                <div class="new_list_cp">
                  <el-row type="flex" v-for="(item,index) in corporateNewsList" :key="index" >
                    <el-col :xs="7" :sm="7" :md="7" :lg="6" :xl="5">
                      <img :src="'/file-server/file/download?fileId='+item.imageId" class="img_animation"  alt="">
                    </el-col>
                    <el-col :xs="17" :sm="16" :md="16" :lg="18" :xl="19" style="padding-left:10px">
                      <el-row style="position:relative">
                        <el-col :span="24">
                          <el-link v-if="lang == 'en-US'" class="newcont" :underline="false"  @click="gotocpnews(item)">{{item.titleEn}}</el-link>
                          <el-link v-if="lang == 'zh-CN'" class="newcont" :underline="false"  @click="gotocpnews(item)">{{item.titleZh}}</el-link>
                        </el-col>
                        <el-col :span="24" style="position:absolute;top:50px">
                          <el-row type="flex" justify="space-between">
                            <el-col :xs="7" :sm="7" :md="7" :lg="8" :xl="8">
                              <p v-if="lang == 'en-US'">{{item.releaseDateEn}}</p>
                              <p v-if="lang == 'zh-CN'">{{formatDates(item.releaseDateZh)}}</p>
                            </el-col>
                            <el-col :xs="17" :sm="17" :md="17" :lg="16" :xl="16">
                              <p>{{$t('home.cpnewlist[0].nyuan')}}<el-link :underline="false" :href='item.sourceUrl' target="_blank" class="link">{{item.sourceText}}</el-link></p>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
            </el-col>
        </el-row>
      </div>

      <!-- 底部轮播 -->
      <div class="foot_box">
            <h3>{{$t('home.consociation')}}</h3>
            <div  class="footer_img_box">
                <img v-for="(item,index) in logoList" :key="index" :src="'/file-server/file/download?fileId='+item.imageId" class="lunbotu img_animation_foot" alt="">
            </div>
        
      </div>

      <Footer :widthmun='windowWidth'/>
  </div>
</template>

<script>

// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Header from '@/components/Header/index.vue';
import Footer from '@/components/Footer/index.vue';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/swiper-bundle.css';
import news from '@/api/new'
import banner from '@/api/banner'
import { getDefaultStartTime, formatDates,formatDate } from "@/util/date";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {Header,Footer,swiper,swiperSlide},
  data () {
  // 这里存放数据
    return {
      availWidth:'',
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      corporateNewsList:[],
      newsList:[],
      _wsc:'',
      bannerList:[],
      logoList:[],
      lang:this.$i18n.locale,
      swiperOption:{
          autoplay: {
              disableOnInteraction: true,  // 用户操作swiper之后，是否禁止autoplay
              delay: 3000, // 自动切换的时间间隔（单位ms）
          },
          slidesPerView:5,  //一行显示3个
          spaceBetween: 30,  //间隔30
          freeMode: true,
          // loop:false,
          speed: 1000,   //滑动速度
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          }
      },
      swiperOptions:{
          autoplay: {
              disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
              delay: 3000, // 自动切换的时间间隔（单位ms）
          },
          slidesPerView:3,  //一行显示3个
          spaceBetween: 30,  //间隔30
          freeMode: true,
          loop:true,
          speed: 1000,   //滑动速度
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          }
      },
      swiperOptions1:{
          autoplay: {
              disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
              delay: 3000, // 自动切换的时间间隔（单位ms）
          },
          slidesPerView:2,  //一行显示3个
          spaceBetween: 30,  //间隔30
          freeMode: true,
          loop:true,
          speed: 1000,   //滑动速度
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          }
      },
    }
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 30) {
        return value.slice(0, 30) + "...";
      }
      return value;
    }
  },
  // 监听属性 类似于data概念
  computed: {
    swiper() {
        return this.$refs.mySwiper.$swiper
    }
  },
  // 监控data中的数据变化
  watch: {
    
      windowHeight (val) {
        let that = this;
        
      },
      windowWidth (val) {
        // let that = this;
        this.windowWidth = val
        // var _wsc = document.createElement('script');
        // _wsc.src = "//tools.prnewswire.com/en-us/live/23389/widget.js";
        // document.getElementsByTagName('Head')[0].appendChild(_wsc);
        // console.log(123,that.swiperOption.slidesPerView)
        // if(val>1250){
        //   this.swiperOption.slidesPerView = 4
        //   this.$refs.mySwiper.swiper.destroy()   //先销毁
        //   this.$refs.mySwiper.mountInstance()   //后在加载
        // }
        // if(val<=1250){
        //   this.swiperOption.slidesPerView = 3
        //   this.$refs.mySwiper.swiper.destroy()   //先销毁
        //   this.$refs.mySwiper.mountInstance()   //后在加载
        // }
        // if(val<=1100){
        //   this.swiperOption.slidesPerView = 2
        //   this.$refs.mySwiper.swiper.destroy()   //先销毁
        //   this.$refs.mySwiper.mountInstance()   //后在加载
        // }
        // if(val<=650){
        //   this.swiperOption.slidesPerView = 2
        //   this.$refs.mySwiper.swiper.destroy()   //先销毁
        //   this.$refs.mySwiper.mountInstance()   //后在加载
        // }
        // console.log('宽',val)
      },
      '$i18n.locale'(val) {
        this.lang = val
        this.getActiveCorporateNewsList(val)
        this.getActiveNewsList(val)
      },
  },
  // 方法集合
  methods: {
    gotonews(row){
      if(row){
        this.$router.push({path:'/News',query: {id: row.id}})
      }else{
        this.$router.push({path:'/News'})
        // this.$router.push({path:'/innewslist'})
      }
    },
    getbannerList(){
      this.bannerList = []
      let data = {'debug':2}
      if(window.location.origin.indexOf('mock') != -1){
          data = {'debug':1}
      }
      banner.getActiveList(response =>{
        if(response.list && response.list.length >= 0){
          this.bannerList = response.list
        }
      },data)
    },
    getLogoList(){
      this.logoList = []
      let data = {'debug':2}
      if(window.location.origin.indexOf('mock') != -1){
          data = {'debug':1}
      }
      banner.getActiveListLogo(response =>{
        if(response.list && response.list.length >= 0){
          this.logoList = response.list
          console.log(33333,this.logoList.length)
        }
      },data)
    },
    gotocpnews(row){
      if(row){
        this.$router.push({path:'/Newscont',query: {id: row.id}})
      }else{
        this.$router.push({path:'/Newslist'})
      }
    },
    getscroll(){
        // console.log('滚动高度',window.pageYOffset)
        // console.log('距离顶部高度',this.$refs.imgani.getBoundingClientRect().top)
    },
    // _isMobile() {
    // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    // console.log(2222,flag)
    // if(flag[0] == "iPhone"){
    //   this.windowWidth = 380; // 宽
    // }
    // return flag;
    // }
    getActiveCorporateNewsList(val){
      
      let data = {
          category:1,
          pageNum:1,
          pageSize:5,
          debug:false
        }
      if(val && val == "zh-CN"){
        data.cnShow = true
      }else{
        data.cnShow = false
      }
      if(window.location.origin.indexOf('mock') != -1){
        data.debug = true
      }
      
      news.getActiveNewsListByCategory(response => {
        if(response.content){
          this.corporateNewsList = response.content
        }
      },data)
    },
    getActiveNewsList(val){
      let data = {
          category:2,
          pageNum:1,
          pageSize:5,
          debug:false,
          cnShow:false,
        }
      if(window.location.origin.indexOf('mock') != -1){
        data.debug = true
      }
      
      news.getActiveNewsListByCategory(response => {
        if(response.content){
          this.newsList = response.content
        }
      },data)
    },
    formatDates: function (dataVal) {
      if (null == dataVal) {
        return "";
      }
      return formatDate(dataVal);
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getActiveCorporateNewsList(this.$i18n.locale)
    this.getActiveNewsList(this.$i18n.locale)
    this.getbannerList()
    this.getLogoList()
    this._wsc = document.createElement('script');
    this._wsc.src = "//tools.prnewswire.com/en-us/live/23389/widget.js";
    document.getElementsByTagName('Head')[0].appendChild(this._wsc);
    this.availWidth = window.screen.availWidth; 
    console.log('window.screen.availWidth',window.screen.availWidth)


  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this._wsc.onload = this._wsc.onreadystatechange = function(){
        // _wsc.onload = _wsc.onreadystatechange=null
        setTimeout(()=>{
          var w23389_widget = document.getElementById('w23389_widget')
          var li = w23389_widget.getElementsByTagName("a");
          for(var i=0;i<li.length;i++){
            li[i].href = li[i].href+'/#/news'
            w23389_widget.style.display="block";
          }
        },2000)
    }

    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    // console.log(123333,document.documentElement.offsetWidth / 750 * 100 + 'px')
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight;  // 高
        that.windowWidth = window.fullWidth; // 宽
      })()
    };
        
          // this._isMobile()
          // console.log(123,document.body.clientWidth,document.body.clientHeight)
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}

</script>
 
<style lang='scss' scoped>

.banner{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
}



// @import url(); 引入公共css类
::v-deep #w23389_widget{
  position: relative;
  display: none;
  .w23389_widgetTitle{
    color: #21212A;
    font-size: 24px;
    color:#21212A;
  }
  ul{
    .w23389_release{
      border-bottom:none;
      padding: 4px 0;
      a{
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-all;
        text-decoration: none;
        color:#21212A;
        margin:10px 0;
        line-height:22px;
        font-size:14px;
        cursor: pointer;
      }
      a:hover{
        color:#000;
        font-weight: 600;
      }
    }
  }
  .w23389_footer{
    position: absolute;
    top: 0px;
    right: 0px;
    a{
      color: #21212A;
      font-size: 14px;
      cursor: pointer;
      text-decoration: none;
    }
  }
}

.img_box{
  
  display: flex;
  align-items: center; /*定义body的元素垂直居中*/
  justify-content: center; /*定义body的里的元素水平居中*/
}
.img_cont_box{
  // position: absolute;
  // left:21%;
  // top:40%;
  // width: 60%;
  margin:0 auto;
  h2{
    width: 55%;
    color:#fff;
    font-size:60px;
    line-height:70px;
    margin: 0 0 25px;
    font-weight: 700;
    text-align: center;
    margin:0 auto;
  }
  p{
    width: 60%;
    padding-top:30px;
    color:#C8C8C8;
    font-size:16px;
    line-height:26px;
    text-align:center;
    margin:0 auto;
  }
}

.new_box{
  width: 88%;
  float: right;
  margin-right: 40px;
  margin-top: 30px;
  h3{
    color:#21212A;
    font-size:24px;
    margin:40px 0;
  }
  p{
    color:#21212A;
    margin:40px 0;
    line-height:22px;
    font-size:14px;
    cursor: pointer;
  }
}
.new_list{
  width: 88%;
  float: right;
  margin-right: 40px;
  .el-link.el-link--default{
    color:#21212A;
    line-height: 22px;
    font-size:14px;
    width: 100%;
    display: block;
    white-space: nowrap;/*一行显示*/
    overflow: hidden;/*超出部分隐藏*/
    text-overflow: ellipsis;
  }
  .el-link.el-link--default:hover{
    color:#000;
    line-height: 22px;
    font-size:15px;
    font-weight: 600;
  }
  p{
    color:#7E7F93;
    line-height: 22px;
    font-size:12px;
  }
  .el-row{
    margin-bottom:50px;
  }
}

.new_box_cp{
  width: 84%;
  margin-left:40px;
  h3{
    color:#21212A;
    font-size:24px;
    margin:40px 0;
  }
  p{
    color:#21212A;
    margin:40px 0;
    line-height:22px;
    font-size:14px;
    cursor: pointer;
  }
}

.new_list_cp{
  width: 84%;
  margin-left:40px;
  .el-link.el-link--default{
    color:#21212A;
    line-height: 22px;
    font-size:14px;
  }
  .newcont{
    width: 100%;
    display: inline-block;
    white-space: nowrap;/*一行显示*/
    overflow: hidden;/*超出部分隐藏*/
    text-overflow: ellipsis;
  }
  .el-link.el-link--default:hover{
    color:#000;
    line-height: 22px;
    font-size:15px;
    font-weight: 600;
  }
  p{
    color:#7E7F93;
    line-height: 22px;
    font-size:12px;
    margin-top:10px;
  }
  .el-row{
    margin-bottom:50px;
  }
}
.img_animation{
  transition: all .3s;
  width: 160px;
  height: 90px;
}
.img_animation:hover{
  transform: scale(1.06);
}
.img_animation_foot{
  transition: all .3s;
  border: 1px solid #e4e7ed;
}
.img_animation_foot:hover{
  transform: scale(1.06);
  box-shadow: 0px 5px 15px rgba(136,136,136,0.2);
}

.link{
  font-size:12px !important;
  color:#7E7F93!important;
  margin-bottom:3px !important;
}
.link:hover{
  color:#7E7F93!important;
  font-size:14px !important;
  font-weight: 400 !important;
}
::v-deep .top_lb_box{
  position: relative;
  height: 660px;
  width: 100%;
  .el-carousel{
    height: 660px;
  }
  .el-carousel__arrow{
    color:transparent;
    width: 70px;
    height:150px;
    border-radius: 0;
  }
  .el-carousel__container{
    height: 100%;
  }
  .el-carousel__arrow--left{
    left:0;
    background: url('../../assets/img/topleftbtn.png') no-repeat;
  }
  .el-carousel__arrow--right{
    right:0;
    background: url('../../assets/img/toprightbtn.png') no-repeat;
  }
  .el-carousel__button{
    width: 8px;
    height:8px;
    border:0.1px solid rgba(255,255,255,0.1);
    border-radius: 50%;
  }
  .el-carousel__indicator--horizontal{
    padding:12px 10px;
  }
}



.img_box_ft{
  margin:0 auto;
  width:300px;
  padding:35px;
  background: #fff;
}

.lunbotu {
    width: 150px;
    background: #fff;
    padding:15px;
}
.lunbotu_mg{
  margin:0 20px;
}
/deep/.swiper-wrapper{
  justify-content: space-between;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next{
  left:95%;
  top:12%;
  color:transparent;
  background: url('../../assets/img/leftbtn.png') no-repeat;
}
.swiper-button-prev:hover, .swiper-container-rtl .swiper-button-next{
  background: url('../../assets/img/leftbtnh.png') no-repeat;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev{
  right:0;
  top:12%;
  color:transparent;
  background: url('../../assets/img/rightbtn.png') no-repeat;
}
.swiper-button-next:hover, .swiper-container-rtl .swiper-button-prev{
  background: url('../../assets/img/rightbtnh.png') no-repeat;
}
.swiper-container{
  position: static;
}
.swiper-container{
  // padding-left:30px;
  padding-right:10px;
}
// ::v-deep .el-carousel__item.is-animating{
//   transition: opacity .6s ease-in-out !important;
// }

.foot_box{
  margin-left: auto;
  margin-right: auto;
  width: 940px;
  h3{
    text-align: center;
    font-size: 26px;
    margin:50px 0;
  }
  .footer_img_box{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .lunbotu{
      margin: 15px;
      width: calc((100% / 5) - 62px);
    }
  }
}

@media screen and (max-width: 1760px){
  ::v-deep .top_lb_box{
    height: 500px;
    .el-carousel{
      height: 500px;
    }
  }
  .banner{
    background-size: auto 100%;
  }
}

@media screen and (min-width: 280px) and (max-width: 768px) {
    .new_box {
        width: 90%;
        h3{
          font-size:26px;
        }
        p{
          font-size: 16px;
        }
    }
    .new_box_cp {
      width: 90%;
        h3{
          font-size:26px;
        }
        p{
          font-size: 16px;
        }
    }
    .new_list{
      width:90%;
      .el-link.el-link--default{
        line-height: 30px;
        font-size:20px;
      }
      .el-link.el-link--default:hover{
        line-height: 30px;
        font-size:20px;
      }
      p{
        line-height: 28px;
        font-size:18px;
      }
    }
    .new_list_cp{
      width: 90%;
      .el-link.el-link--default{
        line-height: 30px;
        font-size:20px;
      }
      .el-link.el-link--default:hover{
        line-height: 30px;
        font-size:20px;
      }
      .link{
        font-size:14px !important;
        color:#7E7F93!important;
        margin-bottom:0px !important;
      }
      .link:hover{
        color:#7E7F93!important;
        font-size:14px !important;
        font-weight: 400 !important;
      }
      p{
        line-height: 28px;
        font-size:18px;
      }
    }
    .lunbotu{
      width: 12%;
    }
    .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
      left:80%
    }
    .img_cont_box{
      h2{
        font-size:30px;
        line-height:40px;
      }
      p{
        font-size:18px;
        line-height:30px;
      }
    }
    .new_box_cp{
      p{
        padding-right:0;
      }
    }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
    ::v-deep .top_lb_box{
      height: 500px;
      .el-carousel{
        height: 500px;
      }
    }
    .banner{
      background-size: 180% 100%;
    }
    .new_box {
        width: 90%;
        h3{
          font-size:28px;
        }
        p{
          font-size: 18px;
        }
    }
    .new_box_cp {
      width: 90%;
        h3{
          font-size:28px;
        }
        p{
          font-size: 18px;
        }
    }
    .new_list{
      width:90%;
      .el-link.el-link--default{
        line-height: 30px;
        font-size:20px;
      }
      .el-link.el-link--default:hover{
        line-height: 30px;
        font-size:20px;
      }
      p{
        line-height: 28px;
        font-size:18px;
      }
    }
    .new_list_cp{
      width: 90%;
      .el-link.el-link--default{
        line-height: 30px;
        font-size:20px;
      }
      .el-link.el-link--default:hover{
        line-height: 30px;
        font-size:20px;
      }
      .link{
        font-size:18px !important;
        color:#7E7F93!important;
        margin-bottom:3px !important;
      }
      .link:hover{
        color:#7E7F93!important;
        font-size:18px !important;
        font-weight: 400 !important;
      }
      p{
        line-height: 28px;
        font-size:18px;
      }
    }
    .lunbotu{
      width: 15%;
      height:60px;
    }
    .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
      left:83%
    }
    .img_cont_box{
      h2{
        font-size:35px;
        line-height:45px;
      }
      p{
        font-size:20px;
        line-height:30px;
      }
    }
    .new_box_cp{
      p{
        padding-right:0;
      }
    }
    .foot_box{
      width: 724px;
      .footer_img_box{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .lunbotu{
          margin: 15px;
          width: calc((100% / 3) - 62px);
        }
      }
    }
}

@media screen and (min-width: 992px) and (max-width: 1242px) {
    .new_box {
        width: 82%;
        h3{
          font-size:24px;
        }
        p{
          font-size: 14px;
        }
    }
    .new_box_cp {
      width: 84%;
        h3{
          font-size:24px;
        }
        p{
          font-size: 14px;
        }
    }
    .new_list{
      width:82%;
      .el-link.el-link--default{
        line-height: 24px;
        font-size:16px;
      }
      .el-link.el-link--default:hover{
        line-height: 24px;
        font-size:16px;
      }
      p{
        line-height: 26px;
        font-size:12px;
      }
    }
    .new_list_cp{
      width: 84%;
      .el-link.el-link--default{
        line-height: 24px;
        font-size:16px;
      }
      .el-link.el-link--default:hover{
        line-height: 16px;
        font-size:16px;
      }
      .link{
        font-size:12px !important;
        color:#7E7F93!important;
        margin-bottom:3px !important;
      }
      .link:hover{
        color:#7E7F93!important;
        font-size:12px !important;
        font-weight: 400 !important;
      }
      p{
        line-height: 26px;
        font-size:12px;
      }
    }
    .containers{
      width: 87% !important;
    }
    .lunbotu{
      width: 130px;
    }
    .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
      left:86%
    }
    .img_cont_box{
      h2{
        font-size:40px;
        line-height:50px;
      }
      p{
        font-size:22px;
        line-height:32px;
      }
    }
    .new_box_cp{
      p{
        padding-right:0;
      }
    }
}
@media screen and (min-width: 1242px) and (max-width: 1600px) {
    .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
      left:95%
    }
    // .lunbotu{
    //   width: 200px;
    // }
    .img_cont_box{
      h2{
        font-size:50px;
        line-height:60px;
      }
      p{
        font-size:24px;
        line-height:34px;
      }
    }
    .new_box_cp{
      p{
        padding-right:35%;
      }
    }
    .new_box {
        width: 80%;
    }
    .new_box_cp {
      width: 94%;
    }
    .new_list{
      width:80%;
    }
    .new_list_cp{
      width: 90%;
    }
    .containers{
      width: 87% !important;
    }
}
@media screen and (min-width: 1600px){
  .new_box {
        width: 80%;
    }
    .new_box_cp {
      width: 76%;
    }
    .new_list{
      width:80%;
    }
    .new_list_cp{
      width: 80%;
    }
}
@media screen and (min-width: 1200px){
  .foot_box{
    width: 1250px;
  }
}




.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
